import * as deepmerge from 'deepmerge';
export function objectCloneDeep(obj) {
  if (typeof obj !== 'object') throw new TypeError('Cannot deepClone non-object!');
  if (obj === null) throw new TypeError('Cannot deepClone null!');
  return deepmerge(Array.isArray(obj) ? [] : {}, obj);
}